$(document).ready(function() {

  $(document).on('click', '.closeFancyBox', function(){
    $('.fancybox-close-small').click();
    console.log("test");
   // $(".fancybox-button--close").trigger('click');
    $.fancybox.close();
  });
  const queryString = window.location.search;
  //alert (queryString);
  const urlParams = new URLSearchParams(queryString);
  const sort_by = urlParams.get('sort_by');
  //alert (sort_by);

  if(sort_by == 'manual'){
    $('select.customSelect').css('width', '101px')
  }
  if(sort_by == 'best-selling'){
    $('select.customSelect').css('width', '122px')
  }
  if(sort_by == 'price-ascending'){
    $('select.customSelect').css('width', '175px')
  }
  if(sort_by == 'price-descending'){
    $('select.customSelect').css('width', '166px')
  }

  $('select.customSelect').change(function(){
    var data = $(this).val();
    //alert(data);
    if(data == 'manual'){
      $(this).css('width', '101px')
    }
    if(data == 'best-selling'){
      $(this).css('width', '122px')
    }
    if(data == 'price-ascending'){
      $(this).css('width', '175px')
    }
    if(data == 'price-descending'){
      $(this).css('width', '166px')
    }

  });
});

$(document).mouseup(function(e) {
  var container = $(".search-box");

  // if the target of the click isn't the container nor a descendant of the container
  if (!container.is(e.target) && container.has(e.target).length === 0) 
  {
    container.find('.results-box').hide();
  }
});

var startDig = 0;
//$(document).on("scroll", "window", function() {
$(document).scroll(function() {


  if($('#AjaxinatePagination').length>0){
    
    var reachLevel = parseFloat($(window).scrollTop())/( parseFloat($(document).height()) - parseFloat($(window).height()) )*100;
    //if((Math.ceil(reachLevel)==93 || Math.ceil(reachLevel)==94 || Math.ceil(reachLevel)==95 || Math.ceil(reachLevel)==96 || Math.ceil(reachLevel)==97) && startDig==0){
    
  
    var top = document.querySelector('#AjaxinatePagination').getBoundingClientRect().top - 0;
    var bottom = document.querySelector('#AjaxinatePagination').getBoundingClientRect().bottom + 0;

    if (top <= window.innerHeight && bottom >= 0 && startDig==0) {
      if($('#AjaxinatePagination a').length>0){
        startDig = 1;

        //$('.all_products').addClass('loading');
        var nextPageUrl = $('#AjaxinatePagination a').attr('href');

        $.ajax({
          type: 'GET',
          url: nextPageUrl,
          success: function(data) {

            $('#AjaxinateContainer').append($(data).find('#AjaxinateContainer').html());
        
            if($(data).find('#AjaxinatePagination a').length>0){
                $('#AjaxinatePagination a').attr('href', $(data).find('#AjaxinatePagination a').attr('href') );
            }else{
                $('#AjaxinatePagination').html('');
            }
            
            $('#AjaxinateContainer').find('.new_come_pro a.grid-link').addClass('load');
            $('#AjaxinateContainer').find('.new_come_pro .pr-content').addClass('load');
            setTimeout(function() {
              $('#AjaxinateContainer').find('.new_come_pro a.grid-link').removeClass('load');
              $('#AjaxinateContainer').find('.new_come_pro .pr-content').removeClass('load');
              $('#AjaxinateContainer').find('.grid__item').removeClass('new_come_pro');
            }, 2000);
            //$('.all_products').removeClass('loading');
            startDig = 0;
            // console.log('hii');
                if (document.body.classList.contains('template-collection')) { 
                  
                    // document.querySelectorAll('.hidden-content-fancy').forEach(function(element) {
                  //   element.addEventListener('scroll', function() {
                  //     console.log('hhh');
                  //     if (element.scrollHeight - element.scrollTop === element.clientHeight) {
                  //       // alert("End");
                  //       element.querySelector('.sticky-add-to-cart').classList.remove('active');
                  //     }else{
                  //       // element.querySelector('.sticky-add-to-cart').classList.add('active');
                  //     }
                  // });
                  // });
                  
                    document.querySelectorAll('.hidden-content-fancy').forEach(function(element) {
                      let lastScrollTop = 0;
                    
                      element.addEventListener('scroll', function() {
                        let st = element.scrollTop;
                    
                        if (st > lastScrollTop) {
                          // Scrolling down
                          // console.log('Scrolling down');
                        } else {
                          // Scrolling up
                          // console.log('Scrolling up');
                          element.querySelector('.sticky-add-to-cart').classList.add('active');
                        }
                    
                        lastScrollTop = st;
                    
                        if (element.scrollHeight - element.scrollTop === element.clientHeight) {
                          // Reached the end of the bottom
                          // alert('hh');
                          element.querySelector('.sticky-add-to-cart').classList.remove('active');
                        }
                      });
                  
                          // For touch events on mobile
                        element.addEventListener('touchmove', function() {
                          // Check if scrolled to the bottom
                          if (isElementAtBottom(element)) {
                            // Reached the end of the bottom
                            element.querySelector('.sticky-add-to-cart').classList.remove('active');
                          }
                        });

                    //for mobile
                    let startY;
                    
                    element.addEventListener('touchstart', function (e) {
                      startY = e.touches[0].clientY;
                    });
                    
                    element.addEventListener('touchmove', function (e) {
                      let currentY = e.touches[0].clientY;
                    
                      if (currentY > startY) {
                        // Scrolling down
                        // alert('Scrolling down');
                        element.querySelector('.sticky-add-to-cart').classList.add('active');
                      } else if (currentY < startY) {
                        // Scrolling up
                        // alert('Scrolling up');
                      }
                    
                      startY = currentY;
                    });
                    });
                   
                  // Function to check if an element is scrolled to the bottom
                  function isElementAtBottom(element) {
                    return element.scrollHeight - element.scrollTop <= element.clientHeight + 1;
                  }
                  
                  
                  }

          }
        });
      }
    }
  }
    

    

    
  //}


});